import { useBoolean } from "ahooks"
import React, { useEffect } from "react"
import Loading from "./components/Loading"
import { init } from "./utils/libs/qywx"
import { loginApp } from "./utils/servers"
import monitor from "./utils/monitor"
import { dealWithIgnoreCase } from "./utils/utils"

type Props = {
  [key: string]: any
}

const PIXEL_SCALE = 50
const DESIGN_WIDTH = 360
const MAX_WIDTH = 600
//跳过身份认证的地址,必然是全地址；
const CROSS_AUTHENTICATION = ["/marketingMaterials/h5", "/scriptLibrary/h5"]

window.addEventListener(
  "load",
  () => {
    monitor()
  },
  false,
)
  ; (function (doc, win) {
    var docEl = doc.documentElement,
      resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
      recalc = function () {
        var clientWidth = docEl.clientWidth
        if (!clientWidth) return
        if (clientWidth >= MAX_WIDTH) {
          docEl.style.fontSize = PIXEL_SCALE * (MAX_WIDTH / DESIGN_WIDTH) + "px"
        } else {
          docEl.style.fontSize = PIXEL_SCALE * (clientWidth / DESIGN_WIDTH) + "px"
        }
      }
    const removedEvent = function () {
      setTimeout(() => {
        const ele = doc.querySelectorAll(".am-modal-wrap")
        if (ele && ele.length && ele.length !== 0) {
          const styleItem = doc?.body?.style
          if (styleItem.overflow !== "hidden") {
            doc.body.setAttribute("style", "overflow:hidden")
          }
        } else {
          doc.body.setAttribute("style", "")
        }
      })
    }
    if (!doc.addEventListener) return
    win.addEventListener(resizeEvt, recalc, false)
    doc.addEventListener("DOMContentLoaded", recalc, false)
    doc.addEventListener("DOMNodeRemoved", removedEvent, false)
  })(document, window)

const InitWarp: React.FC<Props> = (props) => {
  const [loading, { setFalse: appLoadDone }] = useBoolean(true)

  const {
    location: { pathname = "" },
  } = window

  //初始化企业微信插件 判断登录 查询客户信息
  useEffect(() => {
    //!!! 1、登录状态
    if (dealWithIgnoreCase(pathname, CROSS_AUTHENTICATION)) {
      // init({ ready: appLoadDone, onError: appLoadDone })
      appLoadDone()
      return
    }

    loginApp()
      .then((res) => {
        //!!! 2、初始化企业微信配置
        if (res) {
          init({ ready: appLoadDone, onError: appLoadDone })
        }
      })
      .catch((e: any) => {
        console.warn("未登录", e)
      })
  }, [appLoadDone])
  const { children } = props
  return <Loading isloading={loading}>{!loading && children}</Loading>
}

export default InitWarp
